module.exports = function anonymous(data
/**/) {
var out='<div class="key"></div><div class="aspect-outer"> <div class="aspect-inner"> <canvas class="graph-canvas"></canvas> </div></div>';return out;
}